import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResendEmail = _resolveComponent("ResendEmail")!
  const _component_MessageLayout = _resolveComponent("MessageLayout")!

  return (_openBlock(), _createBlock(_component_MessageLayout, {
    image: "./email-cloud.svg",
    altText: "email error",
    title: "Sorry!"
  }, {
    action: _withCtx(() => [
      _createVNode(_component_ResendEmail)
    ]),
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createTextVNode(" There was an issue with your email verification, please try again or contact us to get help. "))
    ]),
    _: 1,
    __: [0]
  }))
}